<div class="container-fluid" style="font-size: 15px">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header" *ngIf="loading">
          <h2>Survey</h2>
          <h4>Loading</h4>
        </div>
        <div class="card-header" *ngIf="exists && !loading">
          <h2>Survey</h2>
          <h4>{{ survey.title }}</h4>
          <label> This survey was completed by {{ total }} users. </label>
        </div>
        <div class="card-header" *ngIf="!exists && !loading">
          <h2>Survey</h2>
          <h4>Not found</h4>
        </div>

        <div class="card-body" *ngIf="exists && !loading">
          <div style="display: flex; align-items: center; justify-content: center" *ngIf="total > 1">
            <div style="width: auto">
              <ul class="col-6 selector">
                <ng-container *ngIf="selectorShowFirstNav">
                  <li class="page-link selector-link" (click)="select(0)">
                    <fa-icon [icon]="['fal','chevron-double-left']"></fa-icon>
                  </li>
                  <li class="page-link selector-link" (click)="select(selected - 1)">
                    <fa-icon [icon]="['fal','chevron-left']"></fa-icon>
                  </li>
                </ng-container>

                <ng-container *ngIf="selectorShowFirstEntry">
                  <li class="page-link selector-link" (click)="select(0)">1</li>
                  <li class="page-link selector-passive">...</li>
                </ng-container>

                <li class="page-link selector-link" *ngFor="let neighbor of selectorLeft" (click)="select(neighbor)">{{ neighbor + 1 }}</li>
                <li class="page-link selector-passive" style="font-weight: bolder">{{ selected + 1 }}</li>
                <li class="page-link selector-link" *ngFor="let neighbor of selectorRight" (click)="select(neighbor)">
                  {{ neighbor + 1 }}
                </li>

                <ng-container *ngIf="selectorShowLastEntry">
                  <li class="page-link selector-passive">...</li>
                  <li class="page-link selector-link" (click)="select(total - 1)">{{ total }}</li>
                </ng-container>

                <ng-container *ngIf="selectorShowLastNav">
                  <li class="page-link selector-link">
                    <fa-icon [icon]="['fal','chevron-right']" (click)="select(selected + 1)"></fa-icon>
                  </li>
                  <li class="page-link selector-link">
                    <fa-icon [icon]="['fal','chevron-double-right']" (click)="select(total - 1)"></fa-icon>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>

          <div *ngIf="result != null">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-left" colspan="2">Overview</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Username</td>
                  <td>{{ result?.userdata?.username }}</td>
                </tr>
                <tr>
                  <td>Alias</td>
                  <td>{{ result?.userdata?.alias }}</td>
                </tr>
                <tr>
                  <td>Date</td>
                  <td>{{ resultDateFmt }}</td>
                </tr>
              </tbody>
            </table>
            <table class="table">
              <thead>
                <tr>
                  <th class="text-left">Survey Question</th>
                  <th class="text-left">User Answer</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let e of result?.payload?.setup?.entries">
                  <ng-container *ngIf="e.type === 'header'">
                    <td colspan="2">{{ e.text }}</td>
                  </ng-container>
                  <ng-container *ngIf="e.type !== 'header'">
                    <td>{{ e.text }}</td>
                    <td>{{ e.result }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="text-center">
            <button class="btn btn-danger btn-sm btn-spaced" (click)="back()">Back</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
